import BankIcon from "shared/icons/bank.svg?react";
import PlaidIcon from "shared/icons/plaidIcon.svg?react";
import { Button, ButtonSize, ButtonVariant } from "shared/components";

interface BankAccountRequiredCardProps {
  plaidLink: string;
  onManualConnect?: () => void;
}

export const BankAccountRequiredCard = ({
  plaidLink,
  onManualConnect
}: BankAccountRequiredCardProps) => {
  return (
    <div className="text-center mx-auto absolute top-1/2 -translate-y-1/2 -translate-x-1/2 left-1/2">
      <div className="mx-auto mb-6 flex h-[100px] w-[100px] items-center justify-center shrink-0 rounded-full bg-primary-20">
        <BankIcon height={40} width={40} />
      </div>
      <h1 className="text-base font-bold text-content-500 mb-2">
        Bank account details required
      </h1>
      <p className="text-sm font-medium text-content-300 mb-6">
        Please connect the bank account for billing purposes
      </p>
      <a target="_blank" className=" mx-auto" href={plaidLink} rel="noreferrer">
        <Button
          className="mb-4 mx-auto !stroke-none"
          size={ButtonSize.BASE}
          variant={ButtonVariant.PRIMARY}
          Icon={PlaidIcon}
        >
          Connect with Plaid Instantly
        </Button>
      </a>
      <Button
        size={ButtonSize.BASE}
        variant={ButtonVariant.TEXT}
        className="text-primary-500"
        onClick={onManualConnect}
      >
        Connect Bank Account Manually
      </Button>
    </div>
  );
};
